/* tslint:disable */
/* eslint-disable */
/**
 * SmartAI WL
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  SmartProblemDetails,
  TermsOfUseReadModel,
  UserBudgetReadModel,
  UserPermissionsDto,
} from '../models/index';
import {
    SmartProblemDetailsFromJSON,
    SmartProblemDetailsToJSON,
    TermsOfUseReadModelFromJSON,
    TermsOfUseReadModelToJSON,
    UserBudgetReadModelFromJSON,
    UserBudgetReadModelToJSON,
    UserPermissionsDtoFromJSON,
    UserPermissionsDtoToJSON,
} from '../models/index';

/**
 * 
 */
export class UsersCurrentApi extends runtime.BaseAPI {

    /**
     */
    async usersCurrentBudgetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserBudgetReadModel>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://852e32be-14b4-4154-884d-b9b5f479493f/access_as_user"]);
        }

        const response = await this.request({
            path: `/api/users/current/budget`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserBudgetReadModelFromJSON(jsonValue));
    }

    /**
     */
    async usersCurrentBudget(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserBudgetReadModel> {
        const response = await this.usersCurrentBudgetRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async usersCurrentGetPermissionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserPermissionsDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://852e32be-14b4-4154-884d-b9b5f479493f/access_as_user"]);
        }

        const response = await this.request({
            path: `/api/users/current/permissions`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserPermissionsDtoFromJSON(jsonValue));
    }

    /**
     */
    async usersCurrentGetPermissions(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserPermissionsDto> {
        const response = await this.usersCurrentGetPermissionsRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async usersCurrentGetTermsOfUseRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TermsOfUseReadModel>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://852e32be-14b4-4154-884d-b9b5f479493f/access_as_user"]);
        }

        const response = await this.request({
            path: `/api/users/current/terms-of-use`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TermsOfUseReadModelFromJSON(jsonValue));
    }

    /**
     */
    async usersCurrentGetTermsOfUse(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TermsOfUseReadModel> {
        const response = await this.usersCurrentGetTermsOfUseRaw(initOverrides);
        return await response.value();
    }

}
